import { format, formatDistanceToNowStrict } from 'date-fns'

const TWO_DAYS_MS = 2 * 24 * 60 * 60 * 1000

// Feed timestamps read relative while fresh ("2 hours ago", "1 day ago") and
// switch to a plain date once they're older than that.
export default function formatFeedTime(createdAt) {
  if (typeof createdAt !== 'number') return ''
  try {
    if (Date.now() - createdAt < TWO_DAYS_MS) {
      return formatDistanceToNowStrict(new Date(createdAt), { addSuffix: true })
    }
    return format(new Date(createdAt), 'PP')
  } catch (e) {
    return ''
  }
}
